import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { JwtPayloadModel, LoginCommand, TokenModel } from '@ose/models';
import { HttpMainService } from '../http-main.service';
import { APP_TOKEN, AppsEnum } from '@ose/enums';
import { JwtHelperService } from '@auth0/angular-jwt';
import { CustomCookieService } from '../utility-services/custom-cookie.service';

@Injectable({
  providedIn: 'root'
})
export class TokensService {
  baseUrl = '/member/';
  private _HttpMainService = inject(HttpMainService);
  private readonly app = inject(APP_TOKEN);
  tokenPrefix = this.app == AppsEnum.SUPPORT ? 'admin-' : '';
  private readonly cookiesService = inject(CustomCookieService);
  private readonly jwtHelper = inject(JwtHelperService);
  jwtPayload?: JwtPayloadModel;
  private accessToken?: string;

  constructor() {
    this.buildJWT();
  }

  refreshAccessToken(): Observable<TokenModel> {
    return this._HttpMainService.put(this.baseUrl + `v1/tokens/current`);
  }

  login(model: LoginCommand): Observable<TokenModel> {
    const url = (this.app === AppsEnum.CLIENT) ? `v1/users/-/tokens` : `v1/admins/-/tokens`
    return this._HttpMainService.post<TokenModel>(this.baseUrl + url, model);
  }

  buildJWT(): void {
    this.accessToken = this.cookiesService.get(`${this.tokenPrefix}access-token`);
    if (this.accessToken)
      this.jwtPayload = this.jwtHelper.decodeToken<JwtPayloadModel>(this.accessToken) || undefined;
  }

  logout(): Observable<null> {
    return this._HttpMainService.delete(this.baseUrl + "v1/tokens/current");
  }

  isTokenValid(): boolean {
    if (this.accessToken) {
      return !this.jwtHelper.isTokenExpired(this.accessToken);
    }
    return false;
  }
}
